(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define([], factory);
	else if(typeof exports === 'object')
		exports["alc-subapp-store-app"] = factory();
	else
		root["alc-subapp-store-app"] = factory();
})(self, function() {
return 